export class ArrayUtils {
	static notFoundPosition = -1;

	static trackById<T extends { id: number | string }>(
		index: number,
		element: T,
	): number | string {
		return element.id;
	}
}
